export enum AuditoriumsPageTabs {
  CURRENT_CINEMAS = 'current-cinemas',
  ARCHIVE = 'archive'
}
